<div class="container">
  <h1 class="mt120">About iTIM</h1>
  <hr class="mb-0" />
</div>

<div class="mainContnet">
  <div class="container">
    <p>
      The Institute for Training in Ministry is a church-based educational
      program that both equips God’s people for ministry, and involves them in
      ministry.
    </p>
    <p>
      It is based on the biblical command to: “equip the saints for the work of
      ministry and so build up the body of Christ” (Ephesians 4:12). Every local
      church can become an iTIM equipping center.
    </p>
    <!-- <div class="aboutImg">
            <img src="./assets/images/aboutImg.png" class="img-fluid" />
            <figcaption class="text-center"><strong>Robert L. Samms</strong></figcaption>
        </div>
        <p><b>The Founder of iTIM</b>. Dr. Robert Samms was a missionary educator in the Philippines from 1957—1979. He taught at the Philippine Missionary Institute, and at the Conservative Baptist Bible College. He also directed the Conservative Baptist Extension Seminary Training and headed the National Office of PAFTEE (Philippine Association for Theological Education by Extension). He served with both the Overseas Missionary Fellowship, and the Conservative Baptist Mission. His education includes an MA in New Testament from Trinity Evangelical Divinity School, and a DMin degree from Denver Seminary.</p>
        <p>On returning to the States in 1979, Bob incorporated Lay Action Ministry Program (LAMP) as a not-for-profit corporation. Developing the strategy, curriculum and pilot-testing the first course was his DMin project at Denver Seminary, which he completed in 1985. Other highly qualified writers of LAMP courses include, Terry Powell, Ch. Ed. Professor at Columbia International University; Dr. Earl McQuay, pastor and adjunct professor at CIU; Dr. Don Fairbairn, Professor of Historical Theology at Erskine Theological Seminary; Jonathan Nelson, extension seminary professor in Spain and Central America; Scott Rowan, Evangelical Free Church pastor; and Wes Haystead, Senior Editor at Gospel Light Publications”.</p>
        <p>A significant step forward took place when David C. Cook adopted LAMP as part of their Adult Elective Curriculum. As the vision to help train God’s people grew, including training overseas and on a pastoral level, it was appropriate to change the name to “Institute for Training in Ministry” (iTIM).</p>
        <p>Currently iTIM is being widely used both in Kenya and in the Philippines, with beginnings in other countries in Africa, and in Southeast Asia, Latin America, and the USA.</p> -->

    <b>The iTIM Curriculum</b>
    <p>
      iTIM consists of 18 interactive courses on 5 ministry “tracks”, beginning
      with personal evangelism and discipleship, through various church
      ministries, church leadership, Bible teaching and pastoral ministry. This
      full curriculum can strengthen and multiply churches. These courses are:
    </p>
    <p><b>Track 1: Discipleship Courses</b></p>
    <ul class="list">
      <li>Christianity 101</li>
      <li>Learning to Serve: Jesus as Role Model</li>
      <li>A Panorama of the Bible.</li>
    </ul>
    <p><b>Track 2: Church Ministry Courses</b></p>
    <ul class="list">
      <li>Welcome to Your Ministry</li>
      <li>How to Discover Your Spiritual Gifts</li>
      <li>Your Ministry of Prayer</li>
      <li>Your Ministry at Home</li>
      <li>Touching Tomorrow by Teaching Children</li>
      <li>Christianity in the Workplace</li>
      <li>Outreach as a Lifestyle</li>
    </ul>
    <p><b>Track 3: Church Leadership Courses</b></p>
    <ul class="list">
      <li>Equipping for Leadership</li>
      <li>Truth That Transforms</li>
    </ul>
    <p><b>Track 4: Bible Teaching Courses</b></p>
    <ul class="list">
      <li>A Survey of the New Testament</li>
      <li>A Survey of the Old Testament</li>
      <li>How to Study the Bible</li>
    </ul>
    <p><b>Track 5: Pastoral Ministry Coursess</b></p>
    <ul class="list">
      <li>Preparing to Preach.</li>
      <li>A Panorama of Christian History</li>
      <li>Contending for the Faith</li>
    </ul>

    <p><b>The iTIM Educational Methodology</b></p>
    <p>
      Our educational methodology focuses on the learner. For this reason, iTIM
      courses are all workbook in format. Learners are asked to first complete
      their lessons individually before participating in the group discussions.
      We also want learners, after first personal study, then group discussion,
      to lead someone else, or a small group, through this material.
    </p>
    <p>
      We call this methodology “head”, “heart”, and “hands”—which means that
      each workbook contains:
    </p>
    <p>HEAD. Significant content, which learners first study on their own.</p>
    <p>HEART. Applications of that content to their personal lives.</p>
    <p>
      HANDS. Learners are then challenged to begin to minister with what they
      have learned.
    </p>
    <p>
      Our conviction is that education is not just for learning biblical truth
      and applying it to heart personally—as important as these aspects of
      learning are. Every iTIM course also includes a practicum, which is
      administrated on the local church level. As this is done, churches will
      grow. If not, it will be no different than other educational materials.
    </p>
    <p><b>The iTIM Seminar</b></p>
    <p>
      By viewing the seminar and taking the related quizzes, your ministry
      success using the iTIM curriculum will be greater. The free iTIM Seminar
      can be completed in 90 to 120 minutes. And, after completing the Seminar,
      you can also download it to share with your leadership team and church
      congregation. You can begin the seminar <a href="/session">HERE</a>.
    </p>
    <p>
      Questions? We are here to help. Please email us:
      <a href="mailto:admin@traininginministry.com"
        >admin@traininginministry.com</a
      >
    </p>
  </div>
  <app-static-footer></app-static-footer>
</div>
